import { render, staticRenderFns } from "./EventSearch.vue?vue&type=template&id=dfaedb52"
import script from "./EventSearch.vue?vue&type=script&lang=js"
export * from "./EventSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports